module.exports = __webpack_public_path__ + "static/editabletable-edac3dfea62dbf736e4f4a91be29098b.gif";